<template>
  <div class="input select">
    <label for="">{{ label }}</label>
    <select
      :value="value"
      @input="updateValue"
      @change="(e) => $emit('change', e)"
    >
      <option v-for="(item, index) in options" :key="index" :value="item.value">
        {{ item.label }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    options: {
      type: [Array, Object],
      default: () => {},
    },
  },
  methods: {
    updateValue(e) {
      this.$emit("input", e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
$screen_desktop: 1200px;
$screen_huge: 1200px;

$sixth_color: #ec8ab3;
$color_text: #383838;
$color_line: #e2e2e6;
$color_error: #f05b78;
$color_gray: #e2e2e6;
$color_gray_text: #929296;
$border_radius: 5px;

$form_input_height: 50px;

$bg_image: #f6f6f9 asset-url("hero-bg.png") repeat;

.input {
  display: flex;
  align-items: center;
  margin: 5px 0;
  position: relative;

  &.hidden {
    display: none;
  }

  &.input--error {
    background-color: $color_error;
    box-shadow: 0 0 0 2px $color_error;
    color: white;
    // border-radius: $border_radius;

    input,
    select {
      box-shadow: 0 0 0 1px $color_error;
      border-color: $color_error;
    }

    .hint {
      display: none;
    }

    .error {
      display: block;
      font-size: 13px;
      padding: 5px 12px;
    }
  }

  .hint {
    display: block;
    font-size: 11px;
    margin: 5px 8px 0;
    color: $color_gray_text;
  }

  input,
  select,
  label {
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
  }

  input,
  select {
    box-sizing: border-box;
    font-size: inherit;
    background-color: white;
    height: $form_input_height;
    line-height: normal;
    padding: 15px;
    width: 100%;
    // border-radius: $border_radius;
    border-width: 0;
    box-shadow: 0 0 0 1px $color_gray;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &:focus {
      box-shadow: 0 0 0 2px #626266;
    }
  }

  label {
    opacity: 0;
    position: absolute;
    left: 15px;
    top: 22px;
    font-size: 15px;
    transform: translateY(-50%);
    height: 11px;
    line-height: 12px;
    margin: 0;
    padding: 0;
    background: 0 0;
  }

  &.filled,
  &.select {
    label {
      color: #454f5b;
      opacity: 1;
      font-size: 11px;
      top: 14px;
      z-index: 1;
    }
    input,
    select {
      padding-top: 18px;
      padding-bottom: 5px;
    }
  }
}

.select {
  position: relative;

  &:before {
    content: "\e93a";
    font-family: "icomoon";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    position: absolute;
    top: 15px;
    right: 15px;
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
}

input,
select,
label {
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

select {
  box-sizing: border-box;
  font-size: inherit;
  background-color: white;
  height: $form_input_height;
  line-height: normal;
  padding: 10px 15px;
  width: 100%;
  // border-radius: $border_radius;
  border-width: 0;
  box-shadow: 0 0 0 1px $color_gray;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  &:focus {
    box-shadow: 0 0 0 2px #626266;
  }
}

@font-face {
  font-family: "icomoon";
  src: url("https://s3.amazonaws.com/static-goengines.gocase.com.br/assets/css/icomoon/icomoon.eot?ze4ebe");
  src: url("https://s3.amazonaws.com/static-goengines.gocase.com.br/assets/css/icomoon/icomoon.eot?ze4ebe#iefix")
      format("embedded-opentype"),
    url("https://s3.amazonaws.com/static-goengines.gocase.com.br/assets/css/icomoon/icomoon.ttf?ze4ebe")
      format("truetype"),
    url("https://s3.amazonaws.com/static-goengines.gocase.com.br/assets/css/icomoon/icomoon.woff?ze4ebe")
      format("woff"),
    url("https://s3.amazonaws.com/static-goengines.gocase.com.br/assets/css/icomoon/icomoon.svg?ze4ebe#icomoon")
      format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

.icon-chevron-down:before {
  content: "\e93a";
}
</style>
